import { Component, ViewEncapsulation } from '@angular/core';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SamAuthService } from './account/shared/sam/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent {
  constructor(private breadCrumbService: BreadcrumbService, private samAuthService: SamAuthService) {
    this.breadCrumbService.set('', { skip: true });
  }
}